export default "__VITE_ASSET__IVZ7FNa5__"